import { useMutation } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'

import * as TypedMessages from '#/lib/typed-messages.js'
import * as SignFrames from '../-frames/sign/index.js'
import * as RemoteRpc from '../-lib/RemoteRpc.js'

export const Route = createFileRoute('/remote/rpc/eth_signTypedData_v4')({
  component: Component,
  validateSearch: (search) => RemoteRpc.validateSearch(search, { method: 'eth_signTypedData_v4' }),
})

function Component() {
  const request = Route.useSearch()
  const rpc = RemoteRpc.use()
  const consumer = RemoteRpc.useConsumer()
  const host = consumer.name ?? consumer.host

  const decoded = request._decoded?.params
  const [, data] = decoded ?? []

  const parsed = useMemo(() => {
    if (!data) return null
    try {
      return JSON.parse(data) as Record<string, unknown>
    } catch {
      return null
    }
  }, [data])

  const confirm = useMutation({
    mutationFn: () => RemoteRpc.execute(rpc, { request }),
  })

  if (parsed && TypedMessages.isPermit(parsed))
    return (
      <SignFrames.Permit
        amount={BigInt(String((parsed.message as any).value))}
        chainId={Number((parsed.domain as any).chainId)}
        confirming={confirm.isPending}
        deadline={Number((parsed.message as any).deadline)}
        host={host}
        onConfirm={() => confirm.mutate()}
        onReject={() => rpc.reject()}
        permitType="erc-2612"
        spender={(parsed.message as any).spender}
        tokenContract={(parsed.domain as any).verifyingContract}
      />
    )

  if (parsed && TypedMessages.isPermit2(parsed))
    return (
      <SignFrames.Permit
        amount={BigInt(String((parsed.message as any).details.amount))}
        chainId={Number((parsed.domain as any).chainId)}
        confirming={confirm.isPending}
        deadline={Number((parsed.message as any).details.expiration)}
        host={host}
        onConfirm={() => confirm.mutate()}
        onReject={() => rpc.reject()}
        permitType="permit2"
        spender={(parsed.message as any).spender}
        tokenContract={(parsed.message as any).details.token}
      />
    )

  if (parsed && TypedMessages.isMppProof(parsed))
    return (
      <SignFrames.Siwe
        confirming={confirm.isPending}
        host={host}
        onApprove={() => confirm.mutate()}
        onReject={() => rpc.reject()}
      />
    )

  if (parsed && TypedMessages.isTypedMessage(parsed))
    return (
      <SignFrames.TypedData
        confirming={confirm.isPending}
        data={parsed as SignFrames.TypedData.Data}
        host={host}
        onConfirm={() => confirm.mutate()}
        onReject={() => rpc.reject()}
      />
    )

  return (
    <SignFrames.TypedDataInvalid
      confirming={confirm.isPending}
      data={data}
      host={host}
      onConfirm={() => confirm.mutate()}
      onReject={() => rpc.reject()}
    />
  )
}
